import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage } from './useLocalStorage';
import { notification } from 'antd';
import userService from '../services/UserService';

const AuthContext = createContext();

// ⚠️ TEMPORARY: Mock user for UI dev without backend. Remove before committing.
// const MOCK_USER = {
//   username: 'dev-user',
//   role: 'ADMIN',
//   accessToken: 'mock-token',
// };

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage('user', null);

  // const [user, setUser] = useLocalStorage('user', MOCK_USER);
  const navigate = useNavigate();
  const location = useLocation();

  // call this function when you want to authenticate the user
  const login = async data => {
    try {
      const response = await userService.login(data);
      if (!response.success) {
        showNotification('error', response.message);
        return;
      }

      // setUser(response.data);
      navigate('/verify?otp-key=' + response.data.otpKey);
    } catch (error) {
      showNotification('error', 'Login failed. Please try again.');
    }
  };
  const verify = async data => {
    try {
      const response = await userService.verify(data);
      if (!response.success) {
        showNotification('error', response.message);
        return;
      }

      setUser(response.data);
      navigate('/');
    } catch (error) {
      showNotification('error', 'Verify failed. Please try again.');
    }
  };

  const showNotification = (type, message) => {
    notification.destroy();
    if (message === 'Access Key is not valid.') {
      logout();
    }
    notification[type]({
      message: message,
      duration: 0,
    });
  };

  // call this function to sign out logged in user
  const logout = () => {
    try {
      setUser(null);
      navigate('/', { replace: true });
    } catch (error) {
      showNotification('error', 'Logout failed. Please try again.');
    }
  };

  useEffect(() => {
    if (
      (!user || !localStorage.getItem('user')) &&
      location.pathname !== '/login' &&
      location.pathname !== '/verify'
    ) {
      logout();
    }
  }, [user, location.pathname]);

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      verify,
      showNotification,
    }),
    [user],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
